import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

const root = document.getElementById('reactRoot')

createRoot(root).render(
  <StrictMode>
    <App productId={root.dataset.productId} />
  </StrictMode>,
)
